import { render, staticRenderFns } from "./SignupAgree.vue?vue&type=template&id=b2beefbe&scoped=true"
import script from "./SignupAgree.vue?vue&type=script&lang=js"
export * from "./SignupAgree.vue?vue&type=script&lang=js"
import style0 from "./SignupAgree.vue?vue&type=style&index=0&id=b2beefbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2beefbe",
  null
  
)

export default component.exports